import { Chip } from '@material-ui/core';
import { getAssessmentStatus, getPrintedCorrectionStatus, getPrintedCorrectionStatusConfig, getStatusConfig } from './status.util';

export function AssessmentStatusChip({ record }) {
  const status = getAssessmentStatus(record);
  const { label, color, backgroundColor } = getStatusConfig(status);

  return (
    <Chip
      label={label}
      size="small"
      style={{ color, backgroundColor, fontWeight: 'bold' }}
    />
  );
}

export function PrintedCorrectionStatusChip({ correctedCount, totalCount }) {
  const status = getPrintedCorrectionStatus({ correctedCount, totalCount });
  const { label, color, backgroundColor, variant } = getPrintedCorrectionStatusConfig(status);

  return (
    <Chip
      label={label}
      size="small"
      variant={variant}
      style={
        variant === 'outlined'
          ? { color, borderColor: color, fontWeight: 'bold' }
          : { color, backgroundColor, fontWeight: 'bold' }
      }
    />
  );
}